module.exports = __webpack_public_path__ + "img/translationeditor_14.86a6964f.jpg";